import { ColumnDetails, ColumnType } from '../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { getExclusionItemTypeGridValues } from '../../../../utils/uiSettings/contentControl/content-control.values';

export enum Column {
  TYPE = 1,
  ENTITY,
  REMARKS,
}

export enum ColumnKeys {
  TYPE = 'type',
  ENTITY = 'entity',
  REMARKS = 'remarks',
}

export const GRID_COLUMNS = [Column.TYPE, Column.ENTITY, Column.REMARKS];

export const FILTERS = [
  { [ColumnKeys.TYPE]: { in: [] } },
  { [ColumnKeys.ENTITY]: { contains: '' } },
  { [ColumnKeys.REMARKS]: { contains: '' } },
];
export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.TYPE, ColumnKeys.ENTITY, ColumnKeys.REMARKS];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.TYPE,
      key: ColumnKeys.TYPE,
      columnName: translateFn('Exclusion type'),
      type: ColumnType.ENUM,
      values: getExclusionItemTypeGridValues(),
      removable: false,
      filteringDisabled: true,
      sortable: true,
      editingDisabled: true,
    },
    {
      column: Column.ENTITY,
      key: ColumnKeys.ENTITY,
      columnName: translateFn('Excluded item'),
      type: ColumnType.STRING,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
    {
      column: Column.REMARKS,
      key: ColumnKeys.REMARKS,
      columnName: translateFn('Description'),
      type: ColumnType.STRING,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
  ];
}
